import { EnrollmentComment } from '../../lib/types/models/enrollment-comment/enrollment-comment'
import { EnrollmentCommentInput } from '../../lib/types/models/enrollment-comment/enrollment-comment-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateEnrollmentComment(
  data: UpdateInput<EnrollmentCommentInput>,
  enrollmentId: number
) {
  const { id, ...rest } = data
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.updateEnrollmentComment.url, {
        id: enrollmentId,
        commentId: id
      })
    )
    .patch<EnrollmentComment>(rest)
}
